import React from "react";
import { buildingStore } from "store/Building/BuildingStore";
import { observer } from "mobx-react-lite";
import CalculationUptodateIndicator from "./CalculationUptodateIndicator";
import CalculationsInProgressIndicator from "./CalculationsInProgressIndicator";
import { isMobileSize } from "utils";

import FilesPopover from "./FilesPopover";

const CalculationProgressIndicator = () => {
  if (
    !buildingStore.calculationsStatus.id ||
    isMobileSize() ||
    !buildingStore.currentBuilding
  )
    return null;

  return (
    <div className="flex items-center">
      {buildingStore.calculationsStatus.inProgress ? (
        <CalculationsInProgressIndicator />
      ) : (
        <CalculationUptodateIndicator />
      )}
      <FilesPopover />
    </div>
  );
};

export default observer(CalculationProgressIndicator);
